import type {
  OutboundCallResponse,
  RowOutboundCallRequest,
} from '@api-contracts/api';
import type { CallListItem } from '@api-contracts/calls';

export type LaunchOutboundCallParams = RowOutboundCallRequest & {
  rowNumber: number;
};

export abstract class CallsRepository {
  public abstract getCallList(): Promise<Array<CallListItem>>;

  public abstract launchOutboundCall(
    params: LaunchOutboundCallParams,
  ): Promise<OutboundCallResponse>;
}
